import { render, staticRenderFns } from "./Visitante.vue?vue&type=template&id=dafe3416&scoped=true"
import script from "./Visitante.vue?vue&type=script&lang=js"
export * from "./Visitante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafe3416",
  null
  
)

export default component.exports